var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ul", { staticClass: "title-nav" }, [
        _c("li", [
          _c(
            "div",
            {
              staticClass: "back-btn",
              on: {
                click: function($event) {
                  return _vm.routeBack()
                }
              }
            },
            [
              _c("i", { staticClass: "material-icons md-18" }, [
                _vm._v("keyboard_arrow_left")
              ])
            ]
          ),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [
          _vm._v("ACTIVE PASSWORD")
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm.mode == "view"
          ? _c("div", { staticClass: "property-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light btn-sm float-right",
                  on: { click: _vm.resetPassword }
                },
                [_vm._v("Reset Password")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.mode == "sent"
          ? _c("div", { staticClass: "property-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light btn-sm float-right",
                  attrs: { disabled: "" },
                  on: { click: _vm.resetPassword }
                },
                [_vm._v("Reset Password")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("contentLoading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c("contentAlert", { attrs: { alert: _vm.alert } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-label" }, [
      _c("i", { staticClass: "material-icons md-18" }, [_vm._v("vpn_key")]),
      _vm._v(" PASSWORD")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "property-row" }, [
      _c("div", { staticClass: "text-break property-locked" }, [
        _vm._v(
          "\n\t\t\t\tYour password is encypted and stored on our secure servers. If you'd like to change your password, click the button below and an email will be sent to you which will include a reset link.\n\t\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b020386", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b020386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agent/agent-password.vue
// module id = null
// module chunks = 